import {
  Box,
  Button,
  ButtonGroup,
  FieldWrapper,
  FlexBox,
  Text,
} from '@dixa/lib-shared-habla';
import { useFormContext, useWatch } from 'react-hook-form';

import { CustomFieldEntity } from 'apis/customFields';

import { AttributeFormFieldValues } from '../../../customAttributeModalForm.types';

import { emptyVisibilityCondition } from './constants';

const genericDescription =
  'Change whether to conditionally show this attribute to agents.';
const entityDescription: Record<CustomFieldEntity, string> = {
  conversation: `${genericDescription} Based on the value of another custom attribute or a conversation property.`,
  contact: `${genericDescription} Based on the value of another custom attribute or a contact property.`,
};

type ToggleVisibilityFormFieldProps = {
  /** The entity id. */
  entityId: string;
};

/** Represents the field for managing options of a custom select attribute. */
export const ToggleVisibilityFormField = ({
  entityId,
}: ToggleVisibilityFormFieldProps): JSX.Element => {
  // TODO: [TEAMS-13693] add `AttributeFormFieldValuesHavingOptions` generic back after updating to RHF v8
  const { control, setValue } =
    useFormContext<Omit<AttributeFormFieldValues, 'options'>>();

  const visibilityCondition = useWatch({
    control: control,
    name: 'visibility_condition',
  });

  const visibilityConditionEnabled = visibilityCondition !== null;

  return (
    <FieldWrapper label="Visibility options" labelFor="visibility">
      <Box padding="0 0 250">
        <Text.Paragraph variant="4" subdued>
          {entityDescription[entityId] ?? genericDescription}
        </Text.Paragraph>
      </Box>

      <FlexBox>
        <ButtonGroup>
          <Button
            variant={visibilityConditionEnabled ? 'secondary' : 'primary'}
            onClick={() => {
              setValue('visibility_condition', null);
            }}
          >
            Always visible
          </Button>
          <Button
            variant={visibilityConditionEnabled ? 'primary' : 'secondary'}
            onClick={() => {
              setValue('visibility_condition', emptyVisibilityCondition);
            }}
          >
            Conditionally visible
          </Button>
        </ButtonGroup>
      </FlexBox>
    </FieldWrapper>
  );
};
